module.exports = __webpack_public_path__ + "img/Flag_of_Mongolia.e0286514.svg";